"use strict";

exports.__esModule = true;
exports.StripeChartWrapper = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _styledComponents = require("styled-components");
var _StripeChartTooltip = require("../../Charts/StripeChart/StripeChartTooltip");
var _Translator = require("../../Core/Translator");
var _SelectionContext = require("../../Core/SelectionContext");
var _common = require("../../ConfigurableLayout/common");
var _utils = require("./utils");
var _excluded = ["theme"];
/* eslint-disable no-unused-vars,jsx-a11y/mouse-events-have-key-events */
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var defaultHoverProps = {
  isActive: false,
  x: null,
  y: null,
  position: _core.Position.LEFT
};
var BRUSH_SELECTION_HEIGHT = 24;
var CHART_SELECTION_TOLERANCE = 5;
function tooltipContent(props) {
  var renderTooltip = props.renderTooltip,
    getLabel = props.getLabel,
    doc = props.doc;
  var content;
  if (renderTooltip) {
    content = renderTooltip(doc);
  } else if (getLabel) {
    content = getLabel(doc);
  }
  return content;
}
function renderBrushSelection(_ref) {
  var isHovering = _ref.isHovering,
    translate = _ref.translate,
    allowBrushing = _ref.allowBrushing,
    setAllowBrushing = _ref.setAllowBrushing,
    setHoverProps = _ref.setHoverProps,
    onBrushReset = _ref.onBrushReset,
    showBrush = _ref.showBrush,
    showAxis = _ref.showAxis,
    theme = _ref.theme;
  var bottomPosition = showAxis ? "0px" : "-19px";
  // Legacy hangs the toggle off the bottom-left corner (below the chart when
  // there is no axis). Modern keeps it inside the chart box as a small pill in
  // the top-right corner, so it never escapes the card.
  var placement = theme.uiModern ? {
    top: "4px",
    right: "4px",
    backgroundColor: "#ffffff",
    boxShadow: theme.ButtonShadow,
    borderRadius: "6px",
    padding: "0 4px 0 2px"
  } : {
    bottom: bottomPosition,
    left: "0px",
    backgroundColor: theme.SelectionModeBackgroundColor,
    borderRadius: "2px"
  };
  return isHovering && showBrush ? /*#__PURE__*/_react["default"].createElement("div", {
    style: Object.assign({
      position: "absolute",
      height: BRUSH_SELECTION_HEIGHT + "px",
      zIndex: 3,
      textAlign: "center"
    }, placement),
    "data-testid": "StripeChartWrapper.BrushSelection"
  }, /*#__PURE__*/_react["default"].createElement(_core.Checkbox, {
    style: {
      color: theme.SelectionModeColor,
      margin: "4px 4px 0 4px"
    },
    checked: allowBrushing,
    onChange: function onChange(event) {
      setAllowBrushing(event.target.checked);
      setHoverProps(defaultHoverProps);
      if (!event.target.checked && onBrushReset) {
        onBrushReset();
      }
    }
  }, /*#__PURE__*/_react["default"].createElement(_core.Icon, {
    icon: _icons.IconNames.TEXT_HIGHLIGHT,
    intent: _core.Intent.NONE,
    title: !allowBrushing ? translate("StripeChart.BrushSelection.enableSelection", "Enable Selection") : translate("StripeChart.BrushSelection.disableSelection", "Disable Selection")
  }))) : null;
}
var StripeChartWrapper = exports.StripeChartWrapper = (0, _styledComponents.withTheme)(function (_ref2) {
  var theme = _ref2.theme,
    props = _objectWithoutPropertiesLoose(_ref2, _excluded);
  var _React$useContext = _react["default"].useContext(_Translator.TranslatorContext),
    translate = _React$useContext.translate;
  var _React$useContext2 = _react["default"].useContext(_SelectionContext.SelectionContext),
    selectorPath = _React$useContext2.selectorPath;
  var _useState = (0, _react.useState)(defaultHoverProps),
    hoverProps = _useState[0],
    setHoverProps = _useState[1];
  var _useState2 = (0, _react.useState)(false),
    isHovering = _useState2[0],
    setHovering = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    allowBrushing = _useState3[0],
    setAllowBrushing = _useState3[1];
  var ref = _react["default"].useRef();
  var timeline = props.timeline,
    children = props.children,
    showBrush = props.showBrush,
    getLabel = props.getLabel,
    renderTooltip = props.renderTooltip,
    height = props.height,
    axis = props.axis,
    onBrushReset = props.onBrushReset,
    path = props.path,
    instantaneousEventList = props.instantaneousEventList,
    time = props.time,
    intervalBetweenEvents = props.intervalBetweenEvents;
  var componentPath = (0, _common.getComponentPath)(path);
  (0, _react.useEffect)(function () {
    if (selectorPath && selectorPath !== componentPath) {
      setAllowBrushing(false);
    }
  }, [selectorPath, componentPath]);
  var handleMouseMove = function handleMouseMove(event) {
    var width = props.width,
      scale = props.scale,
      instantaneousEventList = props.instantaneousEventList,
      interval = props.interval;
    if (ref.current && !allowBrushing) {
      var _ref$current$getBound = ref.current.getBoundingClientRect(),
        left = _ref$current$getBound.left,
        top = _ref$current$getBound.top;
      var x = Math.ceil(event.clientX - left);
      var timeInMs = scale.invert(x).getTime();
      var tolerance = (0, _utils.toleranceFromWidth)(width, CHART_SELECTION_TOLERANCE, interval);
      var data = timeline.find(function (_ref3) {
        var _ref3$interval = _ref3.interval,
          startMillis = _ref3$interval.startMillis,
          endMillis = _ref3$interval.endMillis;
        return timeInMs >= startMillis && timeInMs <= endMillis;
      }) || (0, _utils.findEventsFallingInPixel)(timeline, timeInMs, tolerance);
      setHoverProps({
        isActive: (0, _utils.allowTooltipAxisToBeActive)(event.clientY - top, instantaneousEventList),
        x: x,
        y: event.clientY - top,
        data: data,
        timeInMs: timeInMs,
        position: x > width / 2 ? _core.Position.LEFT : _core.Position.RIGHT
      });
    }
  };
  var handleMouseLeave = function handleMouseLeave() {
    setHovering(false);
    if (!allowBrushing) {
      setHoverProps(defaultHoverProps);
    }
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "StripeChartWrapper",
    role: "presentation",
    "aria-roledescription": "StripeChartHover",
    ref: ref,
    onMouseOver: function onMouseOver() {
      setHovering(true);
    },
    onMouseMove: !allowBrushing ? handleMouseMove : null,
    onMouseLeave: !allowBrushing ? handleMouseLeave : null,
    style: {
      cursor: allowBrushing ? "ew-resize" : "default",
      position: "relative"
    }
  }, /*#__PURE__*/_react["default"].createElement(_StripeChartTooltip.StripeChartTooltip, _extends({
    height: (0, _utils.getStripeChartHeight)(height, false, instantaneousEventList)
  }, hoverProps, {
    renderContent: function renderContent(doc) {
      return tooltipContent({
        doc: doc,
        getLabel: getLabel,
        renderTooltip: renderTooltip
      });
    },
    timezone: time.timezone.name,
    intervalBetweenEvents: intervalBetweenEvents
  })), children({
    showBrush: theme.uiModern ? showBrush : allowBrushing
  }), renderBrushSelection({
    isHovering: isHovering,
    translate: translate,
    allowBrushing: allowBrushing,
    setAllowBrushing: setAllowBrushing,
    setHoverProps: setHoverProps,
    onBrushReset: onBrushReset,
    showBrush: showBrush,
    showAxis: axis,
    theme: theme
  }));
});